import { render, staticRenderFns } from "./iWant.vue?vue&type=template&id=2b06fdf1&scoped=true&"
import script from "./iWant.vue?vue&type=script&lang=js&"
export * from "./iWant.vue?vue&type=script&lang=js&"
import style0 from "./iWant.vue?vue&type=style&index=0&id=2b06fdf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b06fdf1",
  null
  
)

export default component.exports